import { render, staticRenderFns } from "./content-wysiwyg-editor.vue?vue&type=template&id=4370ec2d"
import script from "./content-wysiwyg-editor.vue?vue&type=script&lang=js"
export * from "./content-wysiwyg-editor.vue?vue&type=script&lang=js"
import style0 from "./content-wysiwyg-editor.vue?vue&type=style&index=0&id=4370ec2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports